import React from 'react'

const BacktoTop = () => {
  return (
        <a href="#" className="btn btn-secondary btn-lg-square rounded-circle back-to-top"><i className="fa fa-arrow-up"></i></a> 
  )
}

export default BacktoTop